// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================
   Vault Page – Modern Password Manager UI
   Desktop-first with mobile responsive
   ======================================== */

/* --- Page shell --- */
.vault-page {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 860px;
  margin: 0 auto;
  padding-bottom: 20px;
}

/* --- Header: vault selector + search + add --- */
.vault-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 20px 24px;
  background: var(--panel-bg);
  border-radius: 14px 14px 0 0;
  border: 1px solid var(--wire-blue);
  border-bottom: 1px solid var(--wire-blue);
  box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18);
}

.vault-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1;
  min-width: 180px;
}

.vault-header-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.vault-select-wrapper {
  position: relative;
  flex: 1 1;
  min-width: 0;
}

.vault-select-wrapper::after {
  content: '';
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 6px transparent;
  border-right: 6px transparent;
  border-top: 6px solid #ffffff;
  pointer-events: none;
  z-index: 2;
}

.vault-select {
  width: 100%;
  height: 40px;
  padding: 0 32px 0 12px;
  background: rgba(255, 255, 255, 0.04);
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.vault-select:focus {
  outline: none;
  border-color: var(--wire-blue);
  box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18), 0 0 10px rgba(168, 216, 255, 0.4);
}

.vault-search-wrapper {
  position: relative;
  flex: 1 1;
  min-width: 180px;
}

.vault-search-wrapper .vault-search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #888888;
  font-size: 14px;
  pointer-events: none;
}

.vault-search {
  width: 100%;
  height: 40px;
  padding: 0 12px 0 34px;
  background: rgba(255, 255, 255, 0.04);
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s ease;
}

.vault-search:focus {
  outline: none;
}

.vault-search::placeholder {
  color: #888888;
}

/* --- Add button --- */
.vault-add-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 40px;
  padding: 0 16px;
  background: var(--btn-bg);
  color: #ffffff;
  border: 1px solid var(--wire-green);
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  flex-shrink: 0;
  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);
}

.vault-add-btn:hover {
  transform: translateY(-1px);
  background: var(--btn-bg-hover);
  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 0 10px rgba(165, 243, 176, 0.4);
}

.vault-add-btn:active {
  transform: translateY(0);
}

/* --- Add form panel --- */
.vault-add-form {
  padding: 20px 24px;
  background: var(--panel-bg);
  border: 1px solid var(--wire-blue);
  border-radius: 14px;
  box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18);
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.vault-add-form .field-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.vault-add-form .field-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #999999;
}

.vault-add-form .field-input-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.04);
  border: none;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.vault-add-form .field-input {
  flex: 1 1;
  height: 38px;
  padding: 0 10px;
  background: transparent;
  border: none;
  color: #ffffff;
  font-size: 14px;
  width: 100%;
}

.vault-add-form .field-input::placeholder {
  color: #888888;
}

.vault-add-form .field-input:focus {
  outline: none;
}

.vault-gen-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  padding: 0 12px;
  background: var(--btn-bg);
  color: var(--wire-blue);
  border: 1px solid var(--wire-blue);
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  flex-shrink: 0;
  box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18);
}

.vault-gen-btn:hover {
  background: var(--btn-bg-hover);
  box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18), 0 0 10px rgba(168, 216, 255, 0.4);
}

.vault-form-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-top: 4px;
}

.vault-form-actions .vault-add-btn {
  margin-left: 0;
}

.vault-cancel-btn {
  height: 40px;
  padding: 0 16px;
  background: var(--btn-bg);
  color: #cccccc;
  border: 1px solid var(--wire-purple);
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: inset 0 0 0 1px rgba(201, 168, 255, 0.18);
}

.vault-cancel-btn:hover {
  background: var(--btn-bg-hover);
  border-color: var(--wire-purple);
  box-shadow: inset 0 0 0 1px rgba(201, 168, 255, 0.18), 0 0 10px rgba(201, 168, 255, 0.4);
}

/* --- Item list --- */
.vault-list {
  background: var(--panel-bg);
  border: 1px solid var(--wire-blue);
  border-top: none;
  border-radius: 0 0 14px 14px;
  overflow: hidden;
}

.vault-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 24px;
  background: rgba(0, 0, 0, 0.15);
  border-bottom: 1px solid #444444;
}

.vault-list-count {
  font-size: 12px;
  color: #999999;
  font-weight: 500;
}

/* --- Vault item row --- */
.vault-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.vault-item:last-child {
  border-bottom: none;
}

.vault-item:hover {
  background: rgba(255, 255, 255, 0.04);
}

.vault-item:active {
  background: rgba(255, 255, 255, 0.07);
}

/* Legacy trigger styles for VaultDetail component */
.vault-item-trigger {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  color: #ffffff;
  cursor: pointer;
}

.vault-item-name-row {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.vault-item-name-row span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.25;
}

.vault-tag {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  font-size: 11px;
  line-height: 1.4;
  color: #adb5bd;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 4px;
  white-space: nowrap;
  width: fit-content;
}

.vault-item-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgba(100, 181, 246, 0.12);
  color: #64b5f6;
  flex-shrink: 0;
  font-size: 16px;
}

.vault-item-icon.totp {
  background: rgba(76, 175, 80, 0.12);
  color: #4caf50;
}

.vault-item-content {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.vault-item-name {
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vault-item-detail {
  font-size: 13px;
  color: #999999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vault-item-badges {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.vault-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 500;
  border-radius: 4px;
  white-space: nowrap;
}

.vault-badge--totp {
  background: rgba(76, 175, 80, 0.15);
  color: #66bb6a;
}

.vault-badge--vault {
  background: rgba(255, 255, 255, 0.08);
  color: #adb5bd;
}

.vault-item-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.vault-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: 1px solid var(--wire-purple);
  border-radius: 8px;
  background: var(--btn-bg);
  color: var(--wire-purple);
  cursor: pointer;
  transition: all 0.15s ease;
  box-shadow: inset 0 0 0 1px rgba(201, 168, 255, 0.18);
}

.vault-action-btn:hover {
  background: var(--btn-bg-hover);
  color: #ffffff;
  box-shadow: inset 0 0 0 1px rgba(201, 168, 255, 0.18), 0 0 10px rgba(201, 168, 255, 0.4);
}

.vault-action-btn--delete {
  color: var(--wire-red);
  border-color: var(--wire-red);
  box-shadow: inset 0 0 0 1px rgba(255, 179, 186, 0.18);
}

.vault-action-btn--delete:hover {
  background: var(--btn-bg-hover);
  color: #ffffff;
  box-shadow: inset 0 0 0 1px rgba(255, 179, 186, 0.18), 0 0 10px rgba(255, 179, 186, 0.4);
}

/* --- Empty state --- */
.vault-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 24px;
  text-align: center;
  gap: 16px;
}

.vault-empty-icon {
  font-size: 48px;
  color: #555555;
}

.vault-empty-title {
  font-size: 18px;
  font-weight: 600;
  color: #cccccc;
}

.vault-empty-text {
  font-size: 14px;
  color: #888888;
  max-width: 300px;
}

/* --- Loading overlay --- */
.vault-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  z-index: 9998;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vault-loading-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #333333;
  padding: 24px 32px;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
}

/* --- Detail dialog enhancements --- */
.vault-detail-dialog .MuiDialog-paper {
  background: var(--surface-bg);
  border: 1px solid var(--wire-blue);
  box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18), 0 8px 32px rgba(0, 0, 0, 0.4);
}

.vault-detail-dialog .MuiDialogTitle-root {
  border-bottom: 1px solid var(--wire-blue);
}

.vault-detail-dialog .MuiDialogContent-root {
  padding: 8px 24px 24px !important;
}

.vault-detail-fields {
  background: var(--panel-bg);
  border: 1px solid var(--wire-blue);
  border-radius: 10px;
  padding: 4px 12px;
  margin-bottom: 10px;
  box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18);
}

.vault-detail-field {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 0;
  border-bottom: 1px solid rgba(168, 216, 255, 0.18);
}

.vault-detail-field:last-child {
  margin-bottom: 0;
  border-bottom: none;
}

.vault-detail-field-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: #888888;
  letter-spacing: 0.04em;
  min-width: 60px;
}

.vault-detail-field-value {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #ffffff;
  font-family: 'SF Mono', 'Fira Code', monospace;
  font-size: 14px;
}

.vault-detail-copy-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid var(--wire-blue);
  border-radius: 6px;
  background: var(--btn-bg);
  color: var(--wire-blue);
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.15s ease;
  box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18);
}

.vault-detail-copy-btn:hover {
  background: var(--btn-bg-hover);
  color: #ffffff;
  box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18), 0 0 10px rgba(168, 216, 255, 0.4);
}

/* --- 2FA section in detail --- */
.vault-totp-section {
  margin-top: 16px;
  padding: 16px;
  background: var(--panel-bg);
  border: 1px solid var(--wire-green);
  border-radius: 10px;
  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);
}

.vault-totp-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.vault-totp-header span {
  font-weight: 600;
  font-size: 14px;
}

.vault-totp-code {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 10px;
}

.vault-totp-code-value {
  font-size: 28px;
  font-family: 'SF Mono', 'Fira Code', monospace;
  letter-spacing: 8px;
  color: #ffffff;
  font-weight: 600;
}

.vault-totp-timer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-bottom: 12px;
}

.vault-totp-timer span {
  font-size: 12px;
  color: #888888;
}

.vault-totp-actions {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.vault-totp-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border: 1px solid var(--wire-green);
  border-radius: 6px;
  background: var(--btn-bg);
  font-size: 13px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.vault-totp-action-btn--enable {
  color: var(--wire-green);
  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);
}

.vault-totp-action-btn--enable:hover {
  background: var(--btn-bg-hover);
  color: #ffffff;
  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 0 10px rgba(165, 243, 176, 0.4);
}

.vault-totp-action-btn--refresh {
  border-color: var(--wire-blue);
  color: var(--wire-blue);
  box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18);
}

.vault-totp-action-btn--refresh:hover {
  background: var(--btn-bg-hover);
  color: #ffffff;
  box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18), 0 0 10px rgba(168, 216, 255, 0.4);
}

.vault-totp-action-btn--disable {
  border-color: var(--wire-red);
  color: var(--wire-red);
  box-shadow: inset 0 0 0 1px rgba(255, 179, 186, 0.18);
}

.vault-totp-action-btn--disable:hover {
  background: var(--btn-bg-hover);
  color: #ffffff;
  box-shadow: inset 0 0 0 1px rgba(255, 179, 186, 0.18), 0 0 10px rgba(255, 179, 186, 0.4);
}

/* --- Password generator dialog --- */
.vault-gen-preview {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background: var(--panel-bg);
  border: 1px solid var(--wire-blue);
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18);
}

.vault-gen-preview-text {
  flex: 1 1;
  font-family: 'SF Mono', 'Fira Code', monospace;
  font-size: 15px;
  color: #ffffff;
  word-break: break-all;
  overflow-wrap: anywhere;
}

.vault-gen-slider-label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

/* ========================================
   Mobile Responsive (≤768px)
   ======================================== */
@media (max-width: 768px) {
  .vault-page {
    gap: 0;
    padding-bottom: 10px;
  }

  .vault-header {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    padding: 16px;
  }

  .vault-header-left,
  .vault-header-right {
    flex-direction: column;
    width: 100%;
    min-width: 0;
  }

  .vault-select-wrapper,
  .vault-search-wrapper {
    width: 100%;
    min-width: 0;
  }

  .vault-add-btn {
    width: 100%;
    justify-content: center;
    height: 44px;
  }

  .vault-add-form {
    padding: 16px;
  }

  .vault-item {
    padding: 12px 16px;
  }

  .vault-item-icon {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }

  .vault-item-name {
    font-size: 14px;
  }

  .vault-item-detail {
    font-size: 12px;
  }

  .vault-list-header {
    padding: 8px 16px;
  }

  .vault-empty {
    padding: 40px 16px;
  }

  .vault-empty-icon {
    font-size: 36px;
  }

  .vault-empty-title {
    font-size: 16px;
  }

  /* Touch-friendly action buttons */
  .vault-action-btn {
    width: 40px;
    height: 40px;
  }
}

/* ========================================
   Small Mobile (≤480px)
   ======================================== */
@media (max-width: 480px) {
  .vault-header {
    padding: 12px;
  }

  .vault-add-form {
    padding: 12px;
    gap: 10px;
  }

  .vault-add-form .field-input-wrapper {
    height: 36px;
  }

  .vault-add-form .field-input {
    height: 36px;
    font-size: 13px;
  }

  .vault-add-form .field-label {
    font-size: 10px;
  }

  .vault-add-form .vault-gen-btn {
    height: 36px;
    font-size: 11px;
  }

  .vault-add-btn {
    height: 38px;
    font-size: 13px;
    padding: 0 12px;
  }

  .vault-cancel-btn {
    height: 38px;
    font-size: 13px;
    padding: 0 12px;
  }

  .vault-item {
    padding: 10px 12px;
    gap: 8px;
  }

  .vault-item-icon {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }

  .vault-item-name {
    font-size: 13px;
  }

  .vault-item-detail {
    display: none;
  }

  .vault-item-badges {
    display: none;
  }

  .vault-action-btn {
    width: 36px;
    height: 36px;
  }

  .vault-empty {
    padding: 30px 12px;
  }

  /* Detail dialog — compact on mobile */
  .vault-detail-dialog .MuiDialogTitle-root {
    padding: 12px 16px 4px !important;
    font-size: 16px !important;
  }

  .vault-detail-dialog .MuiDialogContent-root {
    padding: 8px 16px 16px !important;
  }

  .vault-detail-dialog .MuiDialogActions-root {
    padding: 8px 16px 12px !important;
  }

  .vault-detail-fields {
    padding: 2px 10px;
  }

  .vault-detail-field {
    padding: 8px 0;
    gap: 8px;
  }

  .vault-detail-field-label {
    font-size: 10px;
    min-width: 48px;
  }

  .vault-detail-field-value {
    font-size: 12px;
  }

  .vault-detail-copy-btn {
    width: 28px;
    height: 28px;
  }

  .vault-totp-section {
    padding: 10px;
    margin-top: 10px;
  }

  .vault-totp-header span {
    font-size: 12px;
  }

  .vault-totp-code-value {
    font-size: 20px;
    letter-spacing: 4px;
  }

  .vault-totp-action-btn {
    padding: 5px 10px;
    font-size: 11px;
  }

  .vault-gen-preview {
    padding: 8px;
  }

  .vault-gen-preview-text {
    font-size: 12px;
  }

  .vault-select {
    height: 36px;
    font-size: 13px;
  }

  .vault-search {
    height: 36px;
    font-size: 13px;
  }
}

/* ========================================
   Large Desktop (≥1200px)
   ======================================== */
@media (min-width: 1200px) {
  .vault-page {
    max-width: 960px;
  }

  .vault-header {
    padding: 24px 28px;
  }

  .vault-add-form {
    padding: 24px 28px;
  }

  .vault-item {
    padding: 16px 28px;
  }

  .vault-list-header {
    padding: 12px 28px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Vault/Vault.css"],"names":[],"mappings":"AAAA;;;6CAG6C;;AAE7C,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,kCAAkC;EAClC,yCAAyC;EACzC,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;EAC7B,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,qCAAqC;EACrC,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,wFAAwF;AAC1F;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,qCAAqC;EACrC,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,wFAAwF;AAC1F;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,kCAAkC;EAClC,mBAAmB;EACnB,qDAAqD;EACrD,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,+BAA+B;EAC/B,wFAAwF;AAC1F;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,qDAAqD;AACvD;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,wFAAwF;AAC1F;;AAEA,sBAAsB;AACtB;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kDAAkD;EAClD,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,0BAA0B;EAC1B,qDAAqD;AACvD;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,wFAAwF;AAC1F;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,qDAAqD;AACvD;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,wFAAwF;AAC1F;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA,uCAAuC;AACvC;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,oFAAoF;AACtF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,qDAAqD;AACvD;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,wFAAwF;AAC1F;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,aAAa;EACb,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,8CAA8C;EAC9C,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mCAAmC;EACnC,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,qDAAqD;AACvD;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,wFAAwF;AAC1F;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,qDAAqD;AACvD;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,wFAAwF;AAC1F;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,qDAAqD;AACvD;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,wFAAwF;AAC1F;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,2BAA2B;EAC3B,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,SAAO;EACP,8CAA8C;EAC9C,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;6CAE6C;AAC7C;EACE;IACE,MAAM;IACN,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,aAAa;EACf;;EAEA;;IAEE,sBAAsB;IACtB,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,kCAAkC;EAClC;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;;6CAE6C;AAC7C;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA,sCAAsC;EACtC;IACE,iCAAiC;IACjC,0BAA0B;EAC5B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;;6CAE6C;AAC7C;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* ========================================\n   Vault Page – Modern Password Manager UI\n   Desktop-first with mobile responsive\n   ======================================== */\n\n/* --- Page shell --- */\n.vault-page {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 860px;\n  margin: 0 auto;\n  padding-bottom: 20px;\n}\n\n/* --- Header: vault selector + search + add --- */\n.vault-header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  padding: 20px 24px;\n  background: var(--panel-bg);\n  border-radius: 14px 14px 0 0;\n  border: 1px solid var(--wire-blue);\n  border-bottom: 1px solid var(--wire-blue);\n  box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18);\n}\n\n.vault-header-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1;\n  min-width: 180px;\n}\n\n.vault-header-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.vault-select-wrapper {\n  position: relative;\n  flex: 1;\n  min-width: 0;\n}\n\n.vault-select-wrapper::after {\n  content: '';\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 0;\n  height: 0;\n  border-left: 6px transparent;\n  border-right: 6px transparent;\n  border-top: 6px solid #ffffff;\n  pointer-events: none;\n  z-index: 2;\n}\n\n.vault-select {\n  width: 100%;\n  height: 40px;\n  padding: 0 32px 0 12px;\n  background: rgba(255, 255, 255, 0.04);\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  appearance: none;\n  -webkit-appearance: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.vault-select:focus {\n  outline: none;\n  border-color: var(--wire-blue);\n  box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18), 0 0 10px rgba(168, 216, 255, 0.4);\n}\n\n.vault-search-wrapper {\n  position: relative;\n  flex: 1;\n  min-width: 180px;\n}\n\n.vault-search-wrapper .vault-search-icon {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #888888;\n  font-size: 14px;\n  pointer-events: none;\n}\n\n.vault-search {\n  width: 100%;\n  height: 40px;\n  padding: 0 12px 0 34px;\n  background: rgba(255, 255, 255, 0.04);\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.vault-search:focus {\n  outline: none;\n}\n\n.vault-search::placeholder {\n  color: #888888;\n}\n\n/* --- Add button --- */\n.vault-add-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 16px;\n  background: var(--btn-bg);\n  color: #ffffff;\n  border: 1px solid var(--wire-green);\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  flex-shrink: 0;\n  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);\n}\n\n.vault-add-btn:hover {\n  transform: translateY(-1px);\n  background: var(--btn-bg-hover);\n  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 0 10px rgba(165, 243, 176, 0.4);\n}\n\n.vault-add-btn:active {\n  transform: translateY(0);\n}\n\n/* --- Add form panel --- */\n.vault-add-form {\n  padding: 20px 24px;\n  background: var(--panel-bg);\n  border: 1px solid var(--wire-blue);\n  border-radius: 14px;\n  box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18);\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.vault-add-form .field-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.vault-add-form .field-label {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #999999;\n}\n\n.vault-add-form .field-input-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(255, 255, 255, 0.04);\n  border: none;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.vault-add-form .field-input {\n  flex: 1;\n  height: 38px;\n  padding: 0 10px;\n  background: transparent;\n  border: none;\n  color: #ffffff;\n  font-size: 14px;\n  width: 100%;\n}\n\n.vault-add-form .field-input::placeholder {\n  color: #888888;\n}\n\n.vault-add-form .field-input:focus {\n  outline: none;\n}\n\n.vault-gen-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 38px;\n  padding: 0 12px;\n  background: var(--btn-bg);\n  color: var(--wire-blue);\n  border: 1px solid var(--wire-blue);\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  flex-shrink: 0;\n  box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18);\n}\n\n.vault-gen-btn:hover {\n  background: var(--btn-bg-hover);\n  box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18), 0 0 10px rgba(168, 216, 255, 0.4);\n}\n\n.vault-form-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  margin-top: 4px;\n}\n\n.vault-form-actions .vault-add-btn {\n  margin-left: 0;\n}\n\n.vault-cancel-btn {\n  height: 40px;\n  padding: 0 16px;\n  background: var(--btn-bg);\n  color: #cccccc;\n  border: 1px solid var(--wire-purple);\n  border-radius: 8px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: inset 0 0 0 1px rgba(201, 168, 255, 0.18);\n}\n\n.vault-cancel-btn:hover {\n  background: var(--btn-bg-hover);\n  border-color: var(--wire-purple);\n  box-shadow: inset 0 0 0 1px rgba(201, 168, 255, 0.18), 0 0 10px rgba(201, 168, 255, 0.4);\n}\n\n/* --- Item list --- */\n.vault-list {\n  background: var(--panel-bg);\n  border: 1px solid var(--wire-blue);\n  border-top: none;\n  border-radius: 0 0 14px 14px;\n  overflow: hidden;\n}\n\n.vault-list-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 24px;\n  background: rgba(0, 0, 0, 0.15);\n  border-bottom: 1px solid #444444;\n}\n\n.vault-list-count {\n  font-size: 12px;\n  color: #999999;\n  font-weight: 500;\n}\n\n/* --- Vault item row --- */\n.vault-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 24px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.vault-item:last-child {\n  border-bottom: none;\n}\n\n.vault-item:hover {\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.vault-item:active {\n  background: rgba(255, 255, 255, 0.07);\n}\n\n/* Legacy trigger styles for VaultDetail component */\n.vault-item-trigger {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n  color: #ffffff;\n  cursor: pointer;\n}\n\n.vault-item-name-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.vault-item-name-row span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  line-height: 1.25;\n}\n\n.vault-tag {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  font-size: 11px;\n  line-height: 1.4;\n  color: #adb5bd;\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 4px;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n.vault-item-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  background: rgba(100, 181, 246, 0.12);\n  color: #64b5f6;\n  flex-shrink: 0;\n  font-size: 16px;\n}\n\n.vault-item-icon.totp {\n  background: rgba(76, 175, 80, 0.12);\n  color: #4caf50;\n}\n\n.vault-item-content {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.vault-item-name {\n  font-size: 15px;\n  font-weight: 500;\n  color: #ffffff;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.vault-item-detail {\n  font-size: 13px;\n  color: #999999;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.vault-item-badges {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.vault-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  font-size: 11px;\n  font-weight: 500;\n  border-radius: 4px;\n  white-space: nowrap;\n}\n\n.vault-badge--totp {\n  background: rgba(76, 175, 80, 0.15);\n  color: #66bb6a;\n}\n\n.vault-badge--vault {\n  background: rgba(255, 255, 255, 0.08);\n  color: #adb5bd;\n}\n\n.vault-item-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.vault-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border: 1px solid var(--wire-purple);\n  border-radius: 8px;\n  background: var(--btn-bg);\n  color: var(--wire-purple);\n  cursor: pointer;\n  transition: all 0.15s ease;\n  box-shadow: inset 0 0 0 1px rgba(201, 168, 255, 0.18);\n}\n\n.vault-action-btn:hover {\n  background: var(--btn-bg-hover);\n  color: #ffffff;\n  box-shadow: inset 0 0 0 1px rgba(201, 168, 255, 0.18), 0 0 10px rgba(201, 168, 255, 0.4);\n}\n\n.vault-action-btn--delete {\n  color: var(--wire-red);\n  border-color: var(--wire-red);\n  box-shadow: inset 0 0 0 1px rgba(255, 179, 186, 0.18);\n}\n\n.vault-action-btn--delete:hover {\n  background: var(--btn-bg-hover);\n  color: #ffffff;\n  box-shadow: inset 0 0 0 1px rgba(255, 179, 186, 0.18), 0 0 10px rgba(255, 179, 186, 0.4);\n}\n\n/* --- Empty state --- */\n.vault-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 24px;\n  text-align: center;\n  gap: 16px;\n}\n\n.vault-empty-icon {\n  font-size: 48px;\n  color: #555555;\n}\n\n.vault-empty-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #cccccc;\n}\n\n.vault-empty-text {\n  font-size: 14px;\n  color: #888888;\n  max-width: 300px;\n}\n\n/* --- Loading overlay --- */\n.vault-loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(4px);\n  z-index: 9998;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.vault-loading-spinner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #333333;\n  padding: 24px 32px;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);\n}\n\n/* --- Detail dialog enhancements --- */\n.vault-detail-dialog .MuiDialog-paper {\n  background: var(--surface-bg);\n  border: 1px solid var(--wire-blue);\n  box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18), 0 8px 32px rgba(0, 0, 0, 0.4);\n}\n\n.vault-detail-dialog .MuiDialogTitle-root {\n  border-bottom: 1px solid var(--wire-blue);\n}\n\n.vault-detail-dialog .MuiDialogContent-root {\n  padding: 8px 24px 24px !important;\n}\n\n.vault-detail-fields {\n  background: var(--panel-bg);\n  border: 1px solid var(--wire-blue);\n  border-radius: 10px;\n  padding: 4px 12px;\n  margin-bottom: 10px;\n  box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18);\n}\n\n.vault-detail-field {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 0;\n  border-bottom: 1px solid rgba(168, 216, 255, 0.18);\n}\n\n.vault-detail-field:last-child {\n  margin-bottom: 0;\n  border-bottom: none;\n}\n\n.vault-detail-field-label {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: #888888;\n  letter-spacing: 0.04em;\n  min-width: 60px;\n}\n\n.vault-detail-field-value {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #ffffff;\n  font-family: 'SF Mono', 'Fira Code', monospace;\n  font-size: 14px;\n}\n\n.vault-detail-copy-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 1px solid var(--wire-blue);\n  border-radius: 6px;\n  background: var(--btn-bg);\n  color: var(--wire-blue);\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: all 0.15s ease;\n  box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18);\n}\n\n.vault-detail-copy-btn:hover {\n  background: var(--btn-bg-hover);\n  color: #ffffff;\n  box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18), 0 0 10px rgba(168, 216, 255, 0.4);\n}\n\n/* --- 2FA section in detail --- */\n.vault-totp-section {\n  margin-top: 16px;\n  padding: 16px;\n  background: var(--panel-bg);\n  border: 1px solid var(--wire-green);\n  border-radius: 10px;\n  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);\n}\n\n.vault-totp-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.vault-totp-header span {\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.vault-totp-code {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.vault-totp-code-value {\n  font-size: 28px;\n  font-family: 'SF Mono', 'Fira Code', monospace;\n  letter-spacing: 8px;\n  color: #ffffff;\n  font-weight: 600;\n}\n\n.vault-totp-timer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin-bottom: 12px;\n}\n\n.vault-totp-timer span {\n  font-size: 12px;\n  color: #888888;\n}\n\n.vault-totp-actions {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n}\n\n.vault-totp-action-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  border: 1px solid var(--wire-green);\n  border-radius: 6px;\n  background: var(--btn-bg);\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.vault-totp-action-btn--enable {\n  color: var(--wire-green);\n  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);\n}\n\n.vault-totp-action-btn--enable:hover {\n  background: var(--btn-bg-hover);\n  color: #ffffff;\n  box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 0 10px rgba(165, 243, 176, 0.4);\n}\n\n.vault-totp-action-btn--refresh {\n  border-color: var(--wire-blue);\n  color: var(--wire-blue);\n  box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18);\n}\n\n.vault-totp-action-btn--refresh:hover {\n  background: var(--btn-bg-hover);\n  color: #ffffff;\n  box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18), 0 0 10px rgba(168, 216, 255, 0.4);\n}\n\n.vault-totp-action-btn--disable {\n  border-color: var(--wire-red);\n  color: var(--wire-red);\n  box-shadow: inset 0 0 0 1px rgba(255, 179, 186, 0.18);\n}\n\n.vault-totp-action-btn--disable:hover {\n  background: var(--btn-bg-hover);\n  color: #ffffff;\n  box-shadow: inset 0 0 0 1px rgba(255, 179, 186, 0.18), 0 0 10px rgba(255, 179, 186, 0.4);\n}\n\n/* --- Password generator dialog --- */\n.vault-gen-preview {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px;\n  background: var(--panel-bg);\n  border: 1px solid var(--wire-blue);\n  border-radius: 8px;\n  margin-bottom: 16px;\n  box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18);\n}\n\n.vault-gen-preview-text {\n  flex: 1;\n  font-family: 'SF Mono', 'Fira Code', monospace;\n  font-size: 15px;\n  color: #ffffff;\n  word-break: break-all;\n  overflow-wrap: anywhere;\n}\n\n.vault-gen-slider-label {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 4px;\n}\n\n/* ========================================\n   Mobile Responsive (≤768px)\n   ======================================== */\n@media (max-width: 768px) {\n  .vault-page {\n    gap: 0;\n    padding-bottom: 10px;\n  }\n\n  .vault-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n    padding: 16px;\n  }\n\n  .vault-header-left,\n  .vault-header-right {\n    flex-direction: column;\n    width: 100%;\n    min-width: 0;\n  }\n\n  .vault-select-wrapper,\n  .vault-search-wrapper {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .vault-add-btn {\n    width: 100%;\n    justify-content: center;\n    height: 44px;\n  }\n\n  .vault-add-form {\n    padding: 16px;\n  }\n\n  .vault-item {\n    padding: 12px 16px;\n  }\n\n  .vault-item-icon {\n    width: 32px;\n    height: 32px;\n    font-size: 14px;\n  }\n\n  .vault-item-name {\n    font-size: 14px;\n  }\n\n  .vault-item-detail {\n    font-size: 12px;\n  }\n\n  .vault-list-header {\n    padding: 8px 16px;\n  }\n\n  .vault-empty {\n    padding: 40px 16px;\n  }\n\n  .vault-empty-icon {\n    font-size: 36px;\n  }\n\n  .vault-empty-title {\n    font-size: 16px;\n  }\n\n  /* Touch-friendly action buttons */\n  .vault-action-btn {\n    width: 40px;\n    height: 40px;\n  }\n}\n\n/* ========================================\n   Small Mobile (≤480px)\n   ======================================== */\n@media (max-width: 480px) {\n  .vault-header {\n    padding: 12px;\n  }\n\n  .vault-add-form {\n    padding: 12px;\n    gap: 10px;\n  }\n\n  .vault-add-form .field-input-wrapper {\n    height: 36px;\n  }\n\n  .vault-add-form .field-input {\n    height: 36px;\n    font-size: 13px;\n  }\n\n  .vault-add-form .field-label {\n    font-size: 10px;\n  }\n\n  .vault-add-form .vault-gen-btn {\n    height: 36px;\n    font-size: 11px;\n  }\n\n  .vault-add-btn {\n    height: 38px;\n    font-size: 13px;\n    padding: 0 12px;\n  }\n\n  .vault-cancel-btn {\n    height: 38px;\n    font-size: 13px;\n    padding: 0 12px;\n  }\n\n  .vault-item {\n    padding: 10px 12px;\n    gap: 8px;\n  }\n\n  .vault-item-icon {\n    width: 28px;\n    height: 28px;\n    font-size: 12px;\n  }\n\n  .vault-item-name {\n    font-size: 13px;\n  }\n\n  .vault-item-detail {\n    display: none;\n  }\n\n  .vault-item-badges {\n    display: none;\n  }\n\n  .vault-action-btn {\n    width: 36px;\n    height: 36px;\n  }\n\n  .vault-empty {\n    padding: 30px 12px;\n  }\n\n  /* Detail dialog — compact on mobile */\n  .vault-detail-dialog .MuiDialogTitle-root {\n    padding: 12px 16px 4px !important;\n    font-size: 16px !important;\n  }\n\n  .vault-detail-dialog .MuiDialogContent-root {\n    padding: 8px 16px 16px !important;\n  }\n\n  .vault-detail-dialog .MuiDialogActions-root {\n    padding: 8px 16px 12px !important;\n  }\n\n  .vault-detail-fields {\n    padding: 2px 10px;\n  }\n\n  .vault-detail-field {\n    padding: 8px 0;\n    gap: 8px;\n  }\n\n  .vault-detail-field-label {\n    font-size: 10px;\n    min-width: 48px;\n  }\n\n  .vault-detail-field-value {\n    font-size: 12px;\n  }\n\n  .vault-detail-copy-btn {\n    width: 28px;\n    height: 28px;\n  }\n\n  .vault-totp-section {\n    padding: 10px;\n    margin-top: 10px;\n  }\n\n  .vault-totp-header span {\n    font-size: 12px;\n  }\n\n  .vault-totp-code-value {\n    font-size: 20px;\n    letter-spacing: 4px;\n  }\n\n  .vault-totp-action-btn {\n    padding: 5px 10px;\n    font-size: 11px;\n  }\n\n  .vault-gen-preview {\n    padding: 8px;\n  }\n\n  .vault-gen-preview-text {\n    font-size: 12px;\n  }\n\n  .vault-select {\n    height: 36px;\n    font-size: 13px;\n  }\n\n  .vault-search {\n    height: 36px;\n    font-size: 13px;\n  }\n}\n\n/* ========================================\n   Large Desktop (≥1200px)\n   ======================================== */\n@media (min-width: 1200px) {\n  .vault-page {\n    max-width: 960px;\n  }\n\n  .vault-header {\n    padding: 24px 28px;\n  }\n\n  .vault-add-form {\n    padding: 24px 28px;\n  }\n\n  .vault-item {\n    padding: 16px 28px;\n  }\n\n  .vault-list-header {\n    padding: 12px 28px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
